module.exports = __webpack_public_path__ + "img/applyhead05.f8d158e8.webp";